import React, { useEffect, useState } from 'react';
import {HalfPieChartProps} from "./HalfPieChart.props";
import {Box} from "@mui/material";
import {PieChart, pieArcLabelClasses, pieArcClasses} from '@mui/x-charts/PieChart';
import './HalfPieChart.css';
import { roundUpPercentage } from '../../utils/util';

// Helper function to get resilience level and color based on score
const getResilienceLevel = (score: number): { level: string; color: string; textcolor: string } => {
  if (score >= 85 && score <= 100) {
    return { level: 'Elite', color: '#A2BC30', textcolor: '#000000E5' };
  } else if (score >= 70 && score <= 84) {
    return { level: 'Strong', color: '#81D4FB', textcolor: '#000000E5' };
  } else if (score >= 40 && score <= 69) {
    return { level: 'Emerging', color: '#FFC107', textcolor: '#000000E5' };
  } else {
    return { level: 'Developing', color: '#DB071E', textcolor: '#ffffff' };
  }
};


const HalfPieChart : React.FC<HalfPieChartProps> = ({valueScore = null}) => {

  const pieChartStartPoint = -90;
  const [roundedScore, setRoundedScore] = useState<number>(0);
  const [pieChartEndPoint, setPieChartEndPoint] = useState<number>(-90);
  const [resilienceInfo, setResilienceInfo] = useState<{ level: string; color: string, textcolor: string }>({ level: 'Developing', color: '#DB071E', textcolor: '#ffffff'});
  
  useEffect(()=>{
    const numericScore = valueScore !== null && typeof valueScore === "number" ? valueScore : (valueScore !== null ? Number(valueScore) : NaN);
    
    if (!isNaN(numericScore)) {
      const rounded = roundUpPercentage(numericScore);
      const pieChartEndPoint = pieChartStartPoint + 1.8 * numericScore;
      const resilienceData = getResilienceLevel(rounded);
      
      setRoundedScore(rounded);
      setPieChartEndPoint(pieChartEndPoint);
      setResilienceInfo(resilienceData);
    }
  },[valueScore])

  return (
    <>
      <Box className={"left-partial-threat-score"}>
        <Box className={"chart"}>
          <PieChart
            series={[
              {
                startAngle: pieChartStartPoint,
                endAngle: 90,
                paddingAngle: 0,
                innerRadius: 100,
                outerRadius: 145,
                data: [{value: 100, color: '#F2F3F3'}]
              },
              {
                startAngle: pieChartStartPoint,
                endAngle: pieChartEndPoint,
                innerRadius: 104,
                outerRadius: 141,
                arcLabel: 'value',
                data: [{
                  label: 'item',
                  value: roundedScore,
                  color: resilienceInfo.level === 'Strong' ? '#03A9F5': resilienceInfo.color
                }],
              },
            ]}
            sx={{
              [`& .${pieArcLabelClasses.root}`]: {
                fill: '#070738',
                textShadow: "0 0 2px rgba(0, 0, 0, 0.25)",
                fontFamily: "Montserrat",
                fontSize: "45px",
                fontWeight: 700,
                transform: "translate(0, -15%)!important",
              },
              [`& .${pieArcClasses.root}`]: {
                stroke: '#E0E0E0',
              },
            }}
            skipAnimation
            tooltip ={{ trigger: 'none' }}
            slotProps={{
              legend: { hidden: true },
            }}
            margin={{right: 0, left: 0, top: 145}}
          />
        </Box>
        <Box className={"chart-info"} sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginTop: '-10px'
        }}>
          <span style={{
            width:'42px', 
            color: '#808888',
            fontSize: '18px'
          }}>0</span>
          <span style={{
            color: '#808888',
            fontSize: '16px'
          }}>Resilience Score</span>
          <span style={{
            width:'42px', 
            color: '#808888',
            fontSize: '18px',
            textAlign: 'right',
            paddingRight: '6px'
          }}>100</span>
        </Box>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          marginTop: '20px' 
        }}>
          <span style={{ 
            backgroundColor: resilienceInfo.color, 
            color: resilienceInfo.textcolor, 
            borderRadius: '20px',
            padding: '8px 16px', 
            fontWeight: 'bold',
            fontSize: '16px',
            textTransform: 'uppercase'
          }}>
            {resilienceInfo.level}
          </span>
        </Box>
      </Box>
    </>
  );
};

export default HalfPieChart;